import { render, staticRenderFns } from "./AccEvent.vue?vue&type=template&id=2a6f1127&"
import script from "./AccEvent.vue?vue&type=script&lang=js&"
export * from "./AccEvent.vue?vue&type=script&lang=js&"
import style0 from "./AccEvent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports